import Option from './option';

class AddressbookOption extends Option {
  details;

  constructor(description, logo, details) {
    super(description, logo);
    this.details = details;
  }

  async fetchDetails() {
    return this.details;
  }
}

export default AddressbookOption;
